<!-- 站内信全局未读消息  -->
<template>
  <el-popover placement="top-start"
              width="380"
              trigger="hover"
              @show="getMessageList"
              >
    <ul class="unreadMessageList">
      <li><em>站内消息通知</em>
        <!-- <router-link to="/internalMessage"
                     tag="em"
                     class="viewMore">查看更多</router-link> -->
          <em class="viewMore" @click="toInternalMessage">查看更多</em>
      </li>
      <template v-if="messageList.length > 0">
          <ul v-loading="loading">
             <li v-for="(item,index) in messageList"
                :key="index"
                class="messageItem"
                @click="goDetail(item)"
                >
            <div class="content noWrap">{{item.messageContent}}</div>
            <div class="time" >{{item.receiveTime | formatDate}}</div>
            </li> 
          </ul>
      </template>
      <template v-else>
        <li style="text-align:center;">暂无未读消息</li>
      </template>
    </ul>
    <div class="el-icon-bell container"
         slot="reference"
         :class="unReadNum > 0?'tipsIcon':''">
    </div>
  </el-popover>

</template>

<script>
import * as services from './home-service' 

// import { setInterval } from 'timers';
export default {
    data() {
        return {
            messageList: [],
            timer:'',
            storeCode:'',
            loading:true,
            unReadNum:0
        }
    },

    components: {},

    computed: {},

    mounted() {
        this.loop()
    },
    created(){
       
        // this.$store.user.detailInfo.storeCode
        
    },
    methods: {
        //获取未读数量
        getMessageNum() {
          services.getUnReadInternalMessageNum().subscribe((data)=>{
            const res = data && data.response && data.response.data ? data.response.data : {}
            if (res.code === 0 || res.code === '0') {
              this.unReadNum = res.data
            } else {
              this.$message.error(res.msg || '请求失败，请重新请求！')
            }  
          })
        },
        toInternalMessage(){
          // 当用户未完善开票信息时不能离开 财务信息编辑页面
          if(sessionStorage.getItem('NoOrderBillingService') ==1){
            this.$alert('您还未完善开票信息，请完善!', '提示', {
              confirmButtonText: '确定',
              type:'warning'
            })
            return false
          }
          this.$router.push('/internalMessage')
        },
        goDetail(val){
             //未读站内信，先标记已读，然后进入详情页
            services.readSignleMessage({id:val.id}).subscribe((data)=>{
                var res = data.response.data
                if(res.code === 0 || res.code === '0'){
                  // 当用户未完善开票信息时不能离开 财务信息编辑页面
                  if(sessionStorage.getItem('NoOrderBillingService') ==1){
                    this.$alert('您还未完善开票信息，请完善!', '提示', {
                      confirmButtonText: '确定',
                      type:'warning'
                    })
                    return false
                  }
                  this.$router.push({
                      path:'/messageDetail',
                      query:{
                          id:val.id
                      }
                  })
                }else{
                    this.$message.error(res.msg || '请求失败，请重新请求')
                }
            })
        },
        /**
         * @method 
         * @param {type} 参数名 参数说明
         * @return {type} 返回值
         * @desc 获取商家编码
         */
        // getStoreCode() {
        //     return new Promise((resolve) => {
        //         if (this.storeCode) {
        //             resolve(this.storeCode)
        //             return
        //         }
        //         services.checkNewTaskStatus().subscribe((res) => {
        //         if (res.data) {
        //             this.storeCode = res.data.storeCode
        //             resolve(this.storeCode)
        //             return
        //         }
        //         resolve(false)
        //         })
        //     })
        // },
        /**
         * @method 
         * @param {type} 参数名 参数说明
         * @return {type} 返回值
         * @desc 获取未读信息
         */
        getMessageList(){
            this.loading = true
            services.getUnReadInternalMessage().subscribe((data)=>{
                const res =  data.response.data
                if(res.code === 0 || res.code === '0'){
                    this.messageList = res.data.unreadMessageList
                    if(this.messageList.length > 10){
                        this.messageList.length = 10   //未读信息最多展示10条
                    }
                    this.loading = false
                }else {
                    this.$message.error(res.msg || '请求失败，请重新请求！')
                    this.loading = false
                }
            })
        },
        loop() {
            this.getMessageNum()
            this.timer = setInterval(()=>{
                this.getMessageNum()
            },60000)
        }
    },
   filters: {
        formatDate(val, fmt) {
            if(val === ''){
                return ''
            }
            const date = new Date(val)
            fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            }
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + ''
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : str.padStart(2, '0'))
                }
            }
            return fmt
        },
    },
    destroyed(){
        clearInterval(this.timer)
    }
}
</script>
<style lang='less' scoped>
.unreadMessageList {
  li {
    color: #333;
    cursor: pointer;
    font-size: 12px;
    // height: 40px;
    padding: 5px;
    border-bottom: 1px solid #eee;
    &:first-of-type {
      display: flex;
      justify-content: space-between;
      .viewMore {
        color: #418fff;
      }
    }
  }
  .messageItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .content {
      color: #333;
    }
    .time {
      color: #999;
    }
  }
}
.container {
  font-size: 16px;
  position: relative;
  &.tipsIcon::after {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 100%;
    background: #f00;
    position: absolute;
    left: 10px;
  }
}
.noWrap{
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
}
</style>